import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { ProductAdminResponse, ProductsAdminParams } from './types';

export async function getProductsAdmin(params: ProductsAdminParams = {}) {
  const url = '/web/studio/products';

  const queryParams: Record<string, string | number | boolean> = {};

  if (params.includeDestroyed) queryParams.include_destroyed = true;
  if (params.pricedOnly) queryParams.priced_only = true;
  if (params.search) queryParams.search = params.search;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<PaginatedListResponse<ProductAdminResponse>>(url, queryParams);

  return response;
}
